export default __webpack_public_path__ + "static/media/outlook_logo.60a76ffe.png";